import { format, getTime, isValid, parseISO } from 'date-fns';

type GenericRequest<T> = T & { start: Date | null; end: Date | null };
type GenericResponse<T> = T & { start: string | null; end: string | null };

export const DATE_FORMAT = 'yyyy-MM-dd  HH:mm';
export const DATE_ISO_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

export const TIMEZONE_MESSAGE = 'Please note that ProctorFree utilizes the Eastern Time Zone (ET)';

export const duration = (start: number, end: number) => end - start;
export const convertSecondsToMilliseconds = (seconds: number) => {
  return seconds * 1000;
};
export const convertMillisecondsToSeconds = (seconds: number) => {
  return seconds / 1000;
};
export const timelineLabel = (timestamp: number, inMilliseconds = false) => {
  const formattedTimestamp = inMilliseconds ? timestamp / 1000 : timestamp;
  const hours = Math.floor(formattedTimestamp / 60 / 60);

  const minutes = Math.floor(formattedTimestamp / 60) - hours * 60;

  const seconds = Math.floor(formattedTimestamp % 60);

  return [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':');
};

export function convertTimeToSec(value: string) {
  return Number(value.split(':').reduce((acc, time) => String(60 * Number(acc) + +time)));
}

export const formatISO = (value: Date | null) => (value ? format(value, DATE_ISO_FORMAT) : null);

export const normalizeRequestWithDate = <T>(data: GenericRequest<T>): GenericResponse<T> => ({
  ...data,
  start: formatISO(data.start),
  end: formatISO(data.end),
});

export function parseDate(dateToFormat: number[]) {
  if (typeof dateToFormat !== 'undefined' && dateToFormat) {
    const withLeadingZero = dateToFormat.map((num) => String(num).padStart(2, '0'));
    const [year, monthValue, dayOfMonth, hour, minute, second = '00'] = withLeadingZero;
    const dateString = `${year}-${monthValue}-${dayOfMonth}T${hour}:${minute}:${second}`;
    return parseISO(dateString);
  } else {
    return new Date();
  }
}

export function dateTime(dateToFormat: number[], occasion: string) {
  if (dateToFormat != null && typeof dateToFormat !== 'undefined') {
    const date = parseDate(dateToFormat);
    if (isValid(date)) {
      return format(date, 'yyyy-MM-dd HH:mm:ss');
    } else {
      console.error('Date ' + dateToFormat + ' is unable to be parsed!');
      return '';
    }
  } else {
    console.warn(`date (${occasion}) does not exist`);
    return '';
  }
}

export const fullDateTime = (timestamp: number) => {
  if (isValid(timestamp)) {
    return format(timestamp, 'yyyy-MM-dd HH:mm:ss');
  } else {
    console.error('Date ' + timestamp + ' is unable to be parsed!');
    return '';
  }
};
export const currentDateTimeInMs = () => getTime(new Date());
